import yachtManufacturersApiService from '@/services/api/YachtManufacturers'

const emptyModel = {
  name: null,
  logo: null,
  country_id: null
}

const emptyFilters = {
  name: null,
  country_id: null
}

class YachtManufacturer {
  constructor() {
    this.api = yachtManufacturersApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
  }
}

let yachtManufacturer = new YachtManufacturer()

export default yachtManufacturer
